import React from 'react';

import { useNavigate, useParams } from 'react-router';

import { appRoutes, RouterEntitiesId } from '@clearverify/constants';

import { PasswordRequestType, useCheckPasswordRequestExistQuery } from 'src/api';
import { ResetPasswordForm } from 'src/components/account';
import { AuthPaperBox } from 'src/components/auth';
import { FullscreenLoader } from 'src/components/common';
import { useNotification } from 'src/hooks/app';
import { useModal } from 'src/hooks/shared';

export const ResetPasswordPage: React.FC = () => {
  const { spawnNotification } = useNotification();

  const { openModal } = useModal();

  const { passwordResetRequestId } = useParams<{
    [RouterEntitiesId.passwordResetRequest]: string;
  }>();

  const navigate = useNavigate();

  const { data, loading } = useCheckPasswordRequestExistQuery({
    variables: {
      requestId: String(passwordResetRequestId),
      requestType: PasswordRequestType.Reset,
    },
    skip: !passwordResetRequestId,
  });

  React.useEffect(() => {
    if (loading) {
      return;
    }

    if (!data?.checkPasswordRequestExist.success) {
      navigate(appRoutes.auth.index);
      spawnNotification('Reset Password Request not exist or expired', 'error');
    }
  }, [data?.checkPasswordRequestExist.success, loading, navigate, openModal, spawnNotification]);

  if (loading) {
    return <FullscreenLoader />;
  }

  return (
    <AuthPaperBox>
      <ResetPasswordForm />
    </AuthPaperBox>
  );
};
